module.exports = __webpack_public_path__ + "static/WolfeLogoClear-c01f601ce14aceff1d2e37d10bafd36f.png";